"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconLiftGate = function SvgIconLiftGate(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "lift gate icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Lift Gate Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M13.897 8h29.852v22.632h2.307v6.682h-13.84c0 3.317-2.733 6.009-6.105 6.009-3.373 0-6.108-2.692-6.108-6.01h-6.106v-2.799L1 23.872l1.801-2.114 1.422 1.17 9.674-11.357V8zm-8.6 15.817l8.6 7.095V13.721l-8.6 10.096zm17.131 13.43c0 2.073 1.71 3.755 3.82 3.755s3.82-1.682 3.82-3.756c0-2.076-1.71-3.758-3.82-3.758s-3.82 1.682-3.82 3.758z"
  }));
};

var _default = SvgIconLiftGate;
exports.default = _default;